import { useCallback } from 'preact/hooks';

export function useDisableClick(disabled?: boolean, handleClick?: () => void) {
  const handleClickWrapper = useCallback(
    (event: MouseEvent) => {
      if (disabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    [disabled],
  );

  if (!disabled) {
    return handleClick;
  }

  return handleClickWrapper;
}
